'use client';

import Spinner from '@/components/utils/Spinner';
import { Dialog } from 'primereact/dialog';

type Props = {
	isLoading?: boolean;
};

const LoadingDialog = ({ isLoading = false }: Props) => {
	return (
		<Dialog
			header=""
			closable={false}
			visible={isLoading}
			maximized
			style={{ width: '50vw' }}
			className="spinner-modal"
			onHide={() => {}}
			pt={{
				content: () => ({
					className: 'dialog-content-reset',
				}),
			}}
		>
			<Spinner />
		</Dialog>
	);
};

export default LoadingDialog;
